import { render } from "./Content.vue?vue&type=template&id=b5588a96"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=b5588a96&lang=less"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__